<div id="quoteVersioningContainer" class="quote-versioning-container">
  @if (isLoading) {
    <div class="overlay full" id="history-loadingSpinner">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }
  @if (quoteVersionList.length) {
    <ds-table id="quoteVersioningTable" mat-table [dataSource]="quoteVersionList" [displayedColumns]="displayedColumns">
      <ng-container matColumnDef="quoteRevision">
        <th mat-header-cell *matHeaderCellDef>{{appStrings.quote_quoteRevisionLabel}}</th>
        <td [id]="'quoteRevisionNumber_'+i" mat-cell *matCellDef="let quote;let i = dataIndex">
          {{quote.quoteRevisionNumber}}
        </td>
      </ng-container>
      <ng-container matColumnDef="quoteCreatedDate">
        <th mat-header-cell *matHeaderCellDef>{{appStrings.quote_quoteCreatedDateLabel}}</th>
        <td [id]="'quoteCreatedDate_'+i" mat-cell *matCellDef="let quote;let i = dataIndex">
          {{quote.quoteCreatedDate | date:appInfoService.dateFormat}}
        </td>
      </ng-container>
      <ng-container matColumnDef="quoteAmountTotal">
        <th mat-header-cell *matHeaderCellDef>{{appStrings.quote_quoteAmountTotalLabel}}</th>
        <td [id]="'totalAmount_'+i" mat-cell *matCellDef="let quote;let i = dataIndex">
          {{quote.totalAmount | currency: currencySymbol }}
        </td>
      </ng-container>
      <ng-container matColumnDef="quoteAge">
        <th mat-header-cell *matHeaderCellDef>{{appStrings.quote_quoteAgeLabel}}</th>
        <td [id]="'age_'+i" mat-cell *matCellDef="let quote;let i = dataIndex">
          {{quote.age}}
        </td>
      </ng-container>
      <ng-container matColumnDef="quoteActions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td [id]="'revisionActions_'+i" mat-cell class="actions" *matCellDef="let quote;let i = dataIndex">
          <ds-button [id]="'export_'+i" size="medium" type="tertiary" variant="label-icon" [label]="appStrings.button_print" icon="print" (onClick)="printQuote(quote)"
            iconStyle="material-icons-outlined">
          </ds-button>
          <ds-button [id]="'print_'+i" size="medium" type="tertiary" variant="label-icon" [label]="appStrings.button_export" icon="insert_drive_file" (onClick)="exportQuote(quote)"
            iconStyle="material-icons-outlined">
          </ds-button>
          <ds-button [id]="'view_'+i" size="medium" type="tertiary" variant="label-icon" [label]="appStrings.button_email" icon="mail" (onClick)="emailQuote(quote)"
            iconStyle="material-icons-outlined">
          </ds-button>
          <ds-button [id]="'restore_'+i" size="medium" type="tertiary" variant="label-icon" [label]="appStrings.button_restore" icon="refresh" (onClick)="restoreQuote(quote)"
            iconStyle="material-icons-outlined" [isDisabled]="isCompleted">
          </ds-button>
        </td>
      </ng-container>
    </ds-table>
  } @else {
    {{appStrings.noEntriesFound}}
  }
</div>
